import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { makeDonation } from "../../api/services/donationService";

export const makeDonationAction = createAsyncThunk(
  "donation/makeDonation",
  async (donationData, { rejectWithValue }) => {
    try {
      const response = await makeDonation(donationData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to process donation');
    }
  }
);

const donationSlice = createSlice({
  name: "donation",
  initialState: {
    loading: false,
    success: false,
    error: null,
    donationData: null
  },
  reducers: {
    resetDonationState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.donationData = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Handle make donation
      .addCase(makeDonationAction.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(makeDonationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.donationData = action.payload;
      })
      .addCase(makeDonationAction.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetDonationState } = donationSlice.actions;
export default donationSlice.reducer;

